import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./UserQuizSummary.css";
import "chartjs-adapter-date-fns";

function UserQuizSummary({ scores }) {
  const [pracDisplayProfile, setPracDisplayProfile] = useState([]);
  const [userDisplayProfile, setUserDisplayProfile] = useState([]);
  const navigate = useNavigate();

  const empathyScoreHighThreshold = 0.6;
  const empathyScoreLowThreshold = 0.3;

  // show users most recent empathy score, both prac and user
  // get most recent score
  // make most recent scores show as profiles
  useEffect(() => {
    if (scores.length === 0) return;
    let pracScore = {};
    let userScore = {};
    let pracMax = {};
    let userMax = {};

    if (scores.length === 2) {
      pracScore = scores[0]["score"];
      pracMax = scores[0]["maxScore"];
      userScore = scores[1]["score"];
      userMax = scores[1]["maxScore"];
    }
    if (scores.length > 2) {
      for (let i = 0; i < scores.length; i++) {
        if (scores[i]["quiz"] === "practitioner") {
          pracScore = scores[i]["score"];
          pracMax = scores[i]["maxScore"];
        } else if (scores[i]["quiz"] === "user") {
          userScore = scores[i]["score"];
          userMax = scores[i]["maxScore"];
        }
      }
    }

    // Practitioner code (normalized)
    let pracCode = "";
    pracCode +=
      pracScore["Cognitive"] > pracMax["Cognitive"] * empathyScoreHighThreshold
        ? "H"
        : pracScore["Cognitive"] <
          pracMax["Cognitive"] * empathyScoreLowThreshold
        ? "L"
        : "M";
    pracCode +=
      pracScore["Affective"] > pracMax["Affective"] * empathyScoreHighThreshold
        ? "H"
        : pracScore["Affective"] <
          pracMax["Affective"] * empathyScoreLowThreshold
        ? "L"
        : "M";
    pracCode +=
      pracScore["Empathic Response"] >
      pracMax["Empathic Response"] * empathyScoreHighThreshold
        ? "H"
        : pracScore["Empathic Response"] <
          pracMax["Empathic Response"] * empathyScoreLowThreshold
        ? "L"
        : "M";

    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/profile?code=${pracCode}&type=practitioner`,
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((data) => setPracDisplayProfile(data))
      .catch((error) =>
        console.error("Error fetching practitioner profile:", error)
      );

    // User code (normalized)
    let userCode = "";
    userCode +=
      userScore["Cognitive"] > userMax["Cognitive"] * empathyScoreHighThreshold
        ? "H"
        : userScore["Cognitive"] <
          userMax["Cognitive"] * empathyScoreLowThreshold
        ? "L"
        : "M";
    userCode +=
      userScore["Affective"] > userMax["Affective"] * empathyScoreHighThreshold
        ? "H"
        : userScore["Affective"] <
          userMax["Affective"] * empathyScoreLowThreshold
        ? "L"
        : "M";
    userCode +=
      userScore["Empathic Response"] >
      userMax["Empathic Response"] * empathyScoreHighThreshold
        ? "H"
        : userScore["Empathic Response"] <
          userMax["Empathic Response"] * empathyScoreLowThreshold
        ? "L"
        : "M";

    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/profile?code=${pracCode}&type=user`,
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((data) => setUserDisplayProfile(data))
      .catch((error) => console.error("Error fetching user profile:", error));
  }, [scores]);

  return (
    <div className="quiz-summary">
      {scores.length > 0 ? (
        <div className="results-dash-summary">
          <b>Your Most Recent Results</b>: <br />
          <b>Practitioner-to-Practitioner Empathy</b>
          <br />
          {pracDisplayProfile[1]} <br />
          <br />
          {pracDisplayProfile[2]} <br />
          <br />
          <b>Practitioner-to-User Empathy</b>
          <br />
          {userDisplayProfile[1]} <br />
          <br />
          {userDisplayProfile[2]}
        </div>
      ) : (
        <div className="no-scores">
          <h1>
            <b>No Quizzes Completed Yet</b>
          </h1>
          <p>
            Take the quiz to discover your empathy levels. Help us develop a
            more compassionate and insightful software industry.
          </p>
          <button
            onClick={() =>
              navigate(`/consent`, { state: { from: "dashboard" } })
            }
          >
            Take the Quiz
          </button>
        </div>
      )}
    </div>
  );
}

export default UserQuizSummary;
